import React from 'react'
import { Popover, Typography, Tooltip } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'

const LongCellPopUp = ({ value }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isTruncated, setIsTruncated] = React.useState(false)
  const spanRef = React.useRef(null)

  React.useLayoutEffect(() => {
    if (spanRef.current) {
      setIsTruncated(spanRef.current.scrollWidth > spanRef.current.offsetWidth)
    }
  }, [value])

  if (!isTruncated) {
    return (
      <span ref={spanRef} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', maxWidth: '600px' }}>
        {value}
      </span>
    )
  }

  return (
    <>
      <Tooltip title='Click to expand' placement='top'>
        <div
          onClick={e => setAnchorEl(e.currentTarget)}
          style={{ display: 'flex', alignItems: 'center', gap: '6px', maxWidth: '600px', cursor: 'pointer' }}
        >
          <span ref={spanRef} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
            {value}
          </span>
          <OpenInNewIcon style={{ fontSize: '13px', color: '#1976d2', flexShrink: 0, opacity: 0.6 }} />
        </div>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Typography style={{ padding: '1rem', maxWidth: '500px', whiteSpace: 'pre-line', userSelect: 'text' }}>
          {value}
        </Typography>
      </Popover>
    </>
  )
}

export default LongCellPopUp
